import React, { ComponentType } from 'react';

import { DropdownWebItemLoading } from 'src/components/dropdown-web-item-loading';
import { WebItemsWithoutRunPipeline } from 'src/components/pipelines/pages/modals/run-pipeline-modal';
import { branchTarget, BranchTargetProps } from 'src/connect/targets';

export type BranchActionsProps = BranchTargetProps & {
  component: ComponentType<any>;
  principalId: string | undefined;
};

const ConnectBranchActions = (props: BranchActionsProps) => {
  const { principalId, component, repositoryOwner, repositorySlug, name } =
    props;

  return (
    <WebItemsWithoutRunPipeline
      location="org.bitbucket.branch.list.actions"
      principalId={principalId}
      target={branchTarget({
        name,
        repositoryOwner,
        repositorySlug,
      })}
      component={component}
      loadingComponent={DropdownWebItemLoading}
      loadingFailedComponent={() => null}
    />
  );
};

export default ConnectBranchActions;
